import { type PublicPraise, PublicPraiseSchema } from '@cult/schemas';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';

// Detail key sits under the 'praises' prefix so create/update invalidations reach it.
export const praiseKey = (id: string) => ['praises', 'detail', id] as const;

export const usePraise = (id: string) =>
  useQuery<PublicPraise>({
    queryKey: praiseKey(id),
    queryFn: async () => PublicPraiseSchema.parse(await apiFetch<unknown>(`/praises/${id}`)),
    staleTime: 30_000,
  });
